import React, { useEffect } from 'react';
import {
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRouteProps,
  Redirect,
  useLocation,
} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../store/createStore';
import { routesEndpoints } from './endpoint';
import { useAuth } from '../../../hooks/auth';
import { openShowModal, viewModal } from '../../../store/modules/parameter/actions';
import SignIn from '../../../pages/SignIn';
import { config } from '../../../config';
interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  component: React.ComponentType;
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  component: Component,
  ...rest
}: RouteProps) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { user: { data: { verified } }, isSignedIn } = useSelector((state: StoreState) => state.auth);
  const { multistoreSelected } = useSelector((state: StoreState) => state.parameter);

  useEffect(() => {
    const locations = [
      routesEndpoints.REDEFINE_PASSWORD,
      routesEndpoints.CONFIRMATION_MAIL,
      routesEndpoints.VERIFICATION_MAIL,
    ];
    if (
      (!locations.find((loc) => location.pathname.includes(loc))) &&
      (!user && !isSignedIn) &&
      ((!config.isAllowedMultistore) ||
      (config.isAllowedMultistore && multistoreSelected.store_id && !user && !isSignedIn))
    ) {
      dispatch(openShowModal(true));
      dispatch(viewModal(SignIn, { width: '750px', height: '100%' }));
    }
  }, [user, isSignedIn, multistoreSelected, dispatch, location.pathname]);

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        const isLogged = user || isSignedIn;
        if (isLogged && verified === 0 && location.pathname !== routesEndpoints.VERIFICATION_MAIL) {
          return <Redirect
            to={{
              pathname: routesEndpoints.VERIFICATION_MAIL,
              state: { isPrivate, from: location },
            }}
          />
        }

        if (!isPrivate) {
          return <Component />;
        }       

        return isPrivate && isLogged ? (
          <Component />
        ) : (
          <Redirect
            to={{
              pathname: routesEndpoints.HOME,
              state: { isPrivate, from: location },
            }}
          />
        );
      }}
    />
  );
};

export default Route;
